import { render, staticRenderFns } from "./chineseLock.vue?vue&type=template&id=720db463&scoped=true"
import script from "./chineseLock.vue?vue&type=script&lang=js"
export * from "./chineseLock.vue?vue&type=script&lang=js"
import style0 from "./chineseLock.vue?vue&type=style&index=0&id=720db463&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720db463",
  null
  
)

export default component.exports